export default (Actions, Schema, initialState) => (state = initialState, action) => {
  switch (action.type) {
    case Actions.ADD:
    case Actions.UPDATE:
      return state.merge({ [action.id]: action.data });

    case Actions.DELETE:
      return state.delete(action.id);

    case Actions.INJECT_MULTIPLE:
      return state.merge(
        action.data.items.reduce((acc, next) => {
          const existing = state.get(next.id);
          const model = {};
          if (existing) {
            Object.assign(model, existing.getState());
          }
          Object.assign(model, next);
          return { ...acc, [next.id]: new Schema(model) };
        }, {})
      );

    default:
      return state;
  }
};
